export interface IIconProps {
  style?: React.CSSProperties,
  cy: string
}

export const IcoAdd = ({ style = {}, cy }: IIconProps) => {
  return (
    <svg className='icon-add' style={style} viewBox="0 0 48 48" data-cy={`AddIcon${cy}`}>
      <path d="M10 26h12v12c0 1.104 0.896 2 2 2s2-0.896 2-2v-12h12c1.104 0 2-0.896 2-2s-0.896-2-2-2h-12v-12c0-1.104-0.896-2-2-2s-2 0.896-2 2v12h-12c-1.104 0-2 0.896-2 2s0.896 2 2 2z"></path>
    </svg>
  )
}
